import apiV2 from '.'

export const participationsApi = apiV2.injectEndpoints({
  endpoints: builder => ({
    getFlagEvent: builder.query({
      query: ({ domainId, eventId, userId }) => `/domains/${domainId}/events/${eventId}/users/${userId}/flag-event`,
      transformResponse: response => response.data,
    }),
    getParticipation: builder.query({
      query: ({ domainId, eventId, userId }) => ({
        url: `/domains/${domainId}/events/${eventId}/users/${userId}`,
        method: 'GET',
      }),
      transformResponse: response => response.data.participation,
      providesTags: ['PARTICIPATION'],
    }),
  }),
})

export const { useGetFlagEventQuery, useLazyGetParticipationQuery } = participationsApi
